import React from "react";

// Lightweight placeholder logo
const MeetusVrVerticalIcon = ({ className }) => (
  <div className={className} style={{ display: "none" }} />
);

export default MeetusVrVerticalIcon;
